export const expectException = (fn: () => void, message: string) => {
    try {
        fn()
        throw new TestError()
    } catch (error) {
        if (error instanceof TestError) {
            throw new Error(`Expected function to throw an error, but it did not: ${message}`)
        }
    }
}

class TestError extends Error {
    constructor() {
        super()
        this.name = "TestError"
    }
}
